import React, { useEffect, useState } from 'react'

// Retain only the displayed image and one pending replacement, within this card.
// Never cache media across authenticated scopes or retry a failed URL in a loop.
export default function StableFacilityImage({ url, identity, unavailable = false }) {
  const [displayed, setDisplayed] = useState(null)
  useEffect(() => {
    if (!url && !unavailable) { setDisplayed(null); return }
    let abandoned = false
    const image = new Image()
    // A failed/hung refresh may keep the previous pixels briefly, not indefinitely.
    const timeout = setTimeout(() => { if (!abandoned) setDisplayed(null) }, 60_000)
    image.onload = async () => {
      try {
        if (image.decode) await image.decode()
        if (!abandoned) {
          clearTimeout(timeout)
          setDisplayed(url)
        }
      } catch { /* keep prior image until the bounded grace period ends */ }
    }
    if (url) image.src = url
    return () => { abandoned = true; clearTimeout(timeout); image.onload = null; image.src = '' }
  }, [url, identity, unavailable])
  // Expire even a successful image if the page stays open without renewed access.
  useEffect(() => {
    if (!displayed) return
    const expiry = setTimeout(() => setDisplayed(null), 30 * 60_000)
    return () => clearTimeout(expiry)
  }, [displayed])
  return displayed ? <div className="mp-facility-card__image" style={{ backgroundImage: `url(${JSON.stringify(displayed)})` }} aria-hidden="true" /> : null
}
